import { render } from "./TourModal.vue?vue&type=template&id=36c4d510"
import script from "./TourModal.vue?vue&type=script&lang=js"
export * from "./TourModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__